import type { UseFormReturnType } from "@mantine/form";
import type { JSX } from "react";

import { Stack, TextInput } from "@mantine/core";

import classes from "./styles.module.css";

interface CustomerInfoFormValues {
    email: string;
    firstName: string;
    lastName: string;
    isInternationalCaller: boolean;
    currentPlan: string | null;
}

export function CustomerInfoForm({ form }: { form: UseFormReturnType<CustomerInfoFormValues> }): JSX.Element {
    return (
        <Stack gap={0} w="100%">
            <TextInput
                data-testid="first-name-input"
                classNames={{ input: classes.styledInput }}
                mt="sm"
                label="First name"
                key={form.key("firstName")}
                {...form.getInputProps("firstName")}
            />
            <TextInput
                data-testid="last-name-input"
                classNames={{ input: classes.styledInput }}
                mt="sm"
                label="Last name"
                key={form.key("lastName")}
                {...form.getInputProps("lastName")}
            />
            <TextInput
                data-testid="email-input"
                classNames={{ input: classes.styledInput }}
                mt="sm"
                radius="xs"
                label="Email"
                key={form.key("email")}
                {...form.getInputProps("email")}
            />
        </Stack>
    );
}
